'use client';
import { useState } from 'react';

const Collapsible = ({ open, children, title, className, grid }) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleFilterOpening = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <div className={`card ${className}`} onClick={handleFilterOpening} style={{ marginBottom: '5px' }}>
        <div>
          <div className="p-3 py-md-3 d-flex justify-content-between tab-header ">
            <span className="tab-title font-weight-bold">{title}</span>
            <button type="button" className="btn py-0" aria-label={isOpen ? 'Collapse dropdown' : 'Expand dropdown'}>
              {!isOpen ? (
                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.392 1.26C0.86 1.82 0.86 2.688 1.392 3.22C3.436 5.292 6.796 8.848 6.852 8.904C7.132 9.184 7.496 9.324 7.86 9.324C8.196 9.324 8.56 9.184 8.84 8.904C8.896 8.848 12.48 5.348 14.524 3.276C15.056 2.744 15.056 1.876 14.524 1.316C13.992 0.784 13.096 0.784 12.564 1.316L7.86 5.964L3.352 1.26C2.82 0.728 1.924 0.728 1.392 1.26Z"
                    fill="#747474"
                  />
                </svg>
              ) : (
                <svg
                  style={{ rotate: '180deg', transition: '.3s linear' }}
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.392 1.26C0.86 1.82 0.86 2.688 1.392 3.22C3.436 5.292 6.796 8.848 6.852 8.904C7.132 9.184 7.496 9.324 7.86 9.324C8.196 9.324 8.56 9.184 8.84 8.904C8.896 8.848 12.48 5.348 14.524 3.276C15.056 2.744 15.056 1.876 14.524 1.316C13.992 0.784 13.096 0.784 12.564 1.316L7.86 5.964L3.352 1.26C2.82 0.728 1.924 0.728 1.392 1.26Z"
                    fill="#747474"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
        <div className={`${!isOpen ? 'border-bottom-only' : 'border-all'}`}>
          <div>{isOpen && <div className={`p-3 ${grid ? 'collapse-grid ' : ''}`}>{children}</div>}</div>
        </div>
      </div>
    </>
  );
};

export default Collapsible;
